export default "__VITE_ASSET__CV8mAjVS__"